import { DashboardService } from './../../../../core/services/dashboard.service';
import { HotelHeaderInfo } from './../../../../core/store/general/state';
import { IRequest } from './../../../../core/models/request';
import { ChangeSortByOptionAction, ChangeBookingAction, ToggleLoginModal } from './../../../../core/store/general/actions';
import { SortByOptions } from './../../../../core/models/general.model';
import { SharedContainer } from './../../../shared.container';
import { HeaderComponent } from './../header.component';
import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { isLoginModalOpened } from '../../../../core/store/general/selectors';
import {Location} from '@angular/common';
import { Router } from '@angular/router';
import { Angulartics2 } from 'angulartics2';

@Component({
    selector: 'app-results-header',
    templateUrl: 'results-header.component.html',
    styleUrls: ['results-header.component.css']
})

export class ResultsHeaderComponent extends HeaderComponent implements OnInit {

    selecteOption = 'price_low_high';
    isRequestOpen = false;
    prevDate = null;
    isModalOpen = false;
    rn = Math.random();
    @Input() headerType: string;
    @Input() userlogged: boolean;
    @Input() request: IRequest;
    @Input() hotelInfo: HotelHeaderInfo;
    @Input() userInfo;
    @Input() unreadMessages;
    @Output() openNavigation: EventEmitter<any> = new EventEmitter();

    @ViewChild('loginModal', { static: true }) loginModal;

    constructor(protected sharedContainer: SharedContainer, protected dashboardService: DashboardService,
         protected location: Location, protected router: Router, protected angulartics2: Angulartics2) {
        super(sharedContainer, dashboardService, location, router, angulartics2);
    }

    ngOnInit() {
        this.sharedContainer.generalState$.select(isLoginModalOpened).subscribe(opened => {
            if (opened === true) {
                this.bookNow();
                this.sharedContainer.generalState$.dispatch(new ToggleLoginModal(1, {loginModalOpened: false}));
            }
        });
        this.rn = Math.random();
    }

    toggleRequestModal() {
        this.isRequestOpen = !this.isRequestOpen;
    }

    onChange(option) {
        switch (option) {
            case 'price_low_high': {
                this.sharedContainer.generalState$.dispatch(
                    new ChangeSortByOptionAction(
                        1, {sortByOption: SortByOptions.SORT_BY_PRICE_ASC})
                );
                break;
            }
            case 'price_high_low': {
                this.sharedContainer.generalState$.dispatch(
                    new ChangeSortByOptionAction(
                        1, {sortByOption: SortByOptions.SORT_BY_PRICE_DESC})
                );
                break;
            }
            case 'stars': {
                this.sharedContainer.generalState$.dispatch(
                    new ChangeSortByOptionAction(
                        1, {sortByOption: SortByOptions.SORT_BY_STARS})
                );
                break;
            }
            case 'exclusives': {
                this.sharedContainer.generalState$.dispatch(
                    new ChangeSortByOptionAction(
                        1, {sortByOption: SortByOptions.SORT_BY_EXCLUSIVE_CAT})
                );
                break;
            }
            case 'optional': {
                this.sharedContainer.generalState$.dispatch(
                    new ChangeSortByOptionAction(
                        1, {sortByOption: SortByOptions.SORT_BY_OPTIONAL_CAT})
                );
                break;
            }
            default: {
                this.sharedContainer.generalState$.dispatch(
                    new ChangeSortByOptionAction(
                        1, {sortByOption: SortByOptions.SORT_BY_PRICE_ASC})
                );
            }
        }
    }

    getIcon(id) {
        switch (id) {
          case 1:
              return 'icon-aircondition';
          case 5:
              return 'icon-gym';
          case 22:
            return 'icon-family';
          case 30:
            return 'icon-beach';
          case 31:
            return 'icon-food';
          case 43:
            return 'icon-parking';
          case 46:
            return 'icon-wifi';
          case 132:
            return 'icon-pet-friendly';
          default:
            return 'icon-facility';
        }
    }

    getNights(from, to) {
        const date1 = new Date(from);
        const date2 = new Date(to);
        const timeDiff = Math.abs(date2.getTime() - date1.getTime());
        return  Math.ceil(timeDiff / (1000 * 3600 * 24));
    }

    getAdults() {
        return this.request.roompersons.reduce( (sum, current) =>  (sum + parseInt(current.adults, 10)), 0 );
    }

    getChildren() {
        return this.request.roompersons.reduce( (sum, current) =>  (sum + current.children.length), 0 );
    }

    getChildrenAges() {
        let childrenNum = '';
        if (this.request.roompersons.length > 0) {
            const roomPeople = this.request.roompersons;
            roomPeople.map( info => info.children.map(age => (childrenNum += ', ' + age)));
        }
        if (childrenNum.length > 0) {childrenNum = childrenNum.substring(2, childrenNum.length); }
        return childrenNum;
    }

    formatDate(date) {
        const monthNames = [
          'Jan', 'Feb', 'Mar',
          'Apr', 'Ma', 'Jun', 'Jul',
          'Aug', 'Sep', 'Oct',
          'Nov', 'Dec'
        ];
        const day = date.getDate();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();

        return day + ' ' + monthNames[monthIndex] + ' ' + year;
    }

    getFormatedDate(date) {
        const selectedDate = new Date(date);
        return (selectedDate.getDate() + '/'
                + (selectedDate.getMonth() + 1) + '/'
                + selectedDate.getFullYear());
    }

    getPlainDate(date) {
        return new Date(date);
    }

    getDate(unixTime: number) {
        return this.formatDate(new Date(unixTime));
    }

    getArray(size) {
        return new Array(size).fill(0);
    }

    getClassHeader() {
        const text = 'results-header container ';
        if (this.headerType === 'booking') { return text + 'fixed-top booking'; }
        if (this.headerType === 'voucher') { return text + 'confirmation'; }
        return text + 'fixed-top';
    }

    bookNow() {
        if (this.userlogged) {
            this.sharedContainer.generalState$.dispatch(new ChangeBookingAction(1, {isBookingActionEnabled: true}));
        } else {
            this.openLoginModal(false);
        }
    }

    openLoginModal(data) {
        console.log('opening modal...');
        const width = window.innerWidth;
        this.isModalOpen = true;
        this.loginModal.showModal(data);
        this.prevDate = new Date();
    }

    modalClosed(data) {
        this.isModalOpen = false;
        const s1 = document.querySelector('.modal-backdrop');
        if (s1 !== null && s1.parentNode !== null) {
            s1.parentNode.removeChild(s1);
        }
        const s2 = document.querySelector('.modal-backdrop');
        // s2.parentNode.removeChild(s2);
        if (s2 !== null && s2.parentNode !== null) {
            s2.parentNode.removeChild(s2);
        }
    }

    logoutUser(data) {
        this.sharedContainer.logout();
    }

    goBack() {
        this.location.back();
    }

    openNav() {
        console.log('hereee');
        if (this.headerType === 'results') {
            this.openNavigation.emit(['resultsPage', 'results-header']);
        } else if (this.headerType === 'singleHotel') {
            this.openNavigation.emit(['singleHotel', 'results-header']);
        }
    }


}
